import { gql } from "@apollo/client";

export const ADD_TRANSFER360_RESPONSIBLE_PARTY = gql`
  mutation addResponsibleParty {
    addResponsibleParty {
      success
    }
  }
`;